<template>
    <div>
        <div class="addresses-container">
            <div class="flex addresses-container-title">
                <img :src="icAddress" alt="icon perfil">
                <h4>as minhas moradas</h4>
            </div>

            <!-- Empty address -->
            <div class="profile__empty" v-if="addressesData.length === 0 && favoriteAddressData.length === 0 ">
                <img
                    :src="icWarning"
                    alt=""
                    class="star-icon"
                >

                <p>
                    Ainda não tens nenhuma morada associada.<br>
                    Por favor, adiciona uma morada.
                </p>
            </div>

            <div v-if="favoriteAddressData != 0" class="favourite-address">
                <div class="flex favourite-address-container selected">

                    <img :src="orangeStar" alt="" class="star-icon">

                    <div class="w-full">
                        <div class="flex">
                            <h5>{{favoriteAddressData.alias}}</h5>

                            <div v-if="!favoriteAddressData.valid_zipcode" class="tag">
                                <p>apenas take-away</p>
                            </div>
                        </div>

                        <p class="address">{{favoriteAddressData.street}}, {{favoriteAddressData.door}} {{favoriteAddressData.floor}} |  {{favoriteAddressData.postal_code}} {{favoriteAddressData.locality}}</p>
                    </div>

                    <button @click="removeFavourite(favoriteAddressData.alias)" :class="{'disable-pointer-events': hasUiActive}">
                        <img :src="remove" alt="Remover">
                    </button>
                </div>
                <hr class="diviser">
            </div>

            <ul class="mb-6" v-if="addressesData != 0">
                <li v-for="(address, index) in addressesData" :key="index" class="flex favourite-address-container" :id="index+1">

                    <button v-if="address.valid_zipcode" @click="addFavourite(address.alias)" :class="{'disable-pointer-events': hasUiActive}">
                        <img :src="star" alt="Favorito" class="star-icon">
                    </button>

                    <div class="w-full">
                        <div class="flex">
                            <h5>
                                {{ address.alias }}
                            </h5>

                            <div v-if="!address.valid_zipcode" class="tag">
                                <p>apenas take-away</p>
                            </div>
                        </div>
                        <p class="address">{{address.street}}, {{address.door}} {{address.floor}} |  {{address.postal_code}} {{address.locality}}</p>
                    </div>

                    <button @click="removeAddress(address.alias)" :class="{'disable-pointer-events': hasUiActive}">
                        <img :src="remove" alt="Remover">
                    </button>
                </li>
            </ul>

            <button class="btn-empty" @click="addressModalHandler">Nova morada</button>
        </div>
        <div v-if="addressModal" class="toggle-alert">
            <div class="modal-content">
                <div id="addresses-modal" class="card bg-orange-gradLight">
                    <button class="btn-close" @click="onCancel">
                        <img :src="close" alt="close">
                    </button>

                    <h3 class="text-center text-orange">
                        Adicionar nova morada
                    </h3>

                    <p class="sub-title">
                        Por favor, preenche os campos abaixo.
                    </p>

                    <form onkeydown="return event.key != 'Enter';">
                        <div class="flex">
                            <div class="w-full input-container input-small lg:mr-4">
                                <label class="font-body">nome morada*</label>
                                <div class="input-box">
                                    <input type="text" v-model="alias" class="form-control"  placeholder="Nome morada">
                                    <span class="text-danger error" v-if="formError.alias && formError.alias.length > 0">{{ formError.alias[0] }}</span>
                                </div>
                            </div>
                            <div class="w-full input-container">
                                <label class="font-body">morada*</label>
                                <div class="input-box">
                                    <input type="text" v-model="street" class="form-control"  placeholder="Morada">
                                    <span class="text-danger error" v-if="formError.street && formError.street.length > 0">{{ formError.street[0] }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="w-full input-container input-small lg:mr-4">
                                <label class="font-body">número*</label>
                                <div class="input-box">
                                    <input type="text" v-model="door" class="form-control"  placeholder="Número">
                                    <span class="text-danger error" v-if="formError.door && formError.door.length > 0">{{ formError.door[0] }}</span>
                                </div>
                            </div>
                            <div class="w-full input-container input-small lg:mr-4">
                                <label class="font-body">andar</label>
                                <div class="input-box">
                                    <input type="text" v-model="floor" class="form-control"  placeholder="Andar">
                                    <span class="text-danger error" v-if="formError.floor && formError.floor.length > 0">{{ formError.floor[0] }}</span>
                                </div>
                            </div>
                            <div class="w-full input-container input-small">
                                <label class="font-body">lado</label>
                                <div class="input-box">
                                    <input type="text" v-model="side" class="form-control"  placeholder="Lado">
                                    <span class="text-danger error" v-if="formError.side && formError.side.length > 0">{{ formError.side[0] }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="w-full input-container input-small lg:mr-4">
                                <label class="font-body">código postal*</label>
                                <div class="input-box">
                                    <input type="text" v-model="postal_code" class="form-control"  placeholder="Código Postal">
                                    <span class="text-danger error" v-if="formError.postal_code && formError.postal_code.length > 0">{{ formError.postal_code[0] }}</span>
                                </div>
                            </div>
                            <div class="w-full input-container input-small lg:mr-4">
                                <label class="font-body">localidade*</label>
                                <div class="input-box">
                                    <input type="text" v-model="locality" class="form-control"  placeholder="Localidade">
                                    <span class="text-danger error" v-if="formError.locality && formError.locality.length > 0">{{ formError.locality[0] }}</span>
                                </div>
                            </div>
                            <div class="self-end w-full input-container input-small">
                                <p class="text-center bottom-text lg:text-right">*campos obrigatórios</p>
                            </div>
                        </div>
                        <div class="modal-bottom double">
                            <div class="text-center">
                                <button class="recover text-orange" @click="onCancel"><strong>Cancelar</strong></button>
                            </div>
                            <div class="text-center">
                                <button class="btn-bg" :class="{'disabled': isLoading}" @click="onConfirm">Adicionar morada</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icWarning from '../../svg/ic_warning_grey.svg'
import icAddress from '../../svg/ic_address.svg'
import icOrangeStar from '../../svg/ic_favorite_selected.svg'
import icStar from '../../svg/ic_favorite_outline.svg'
import icRemove from '../../svg/ic_remove.svg'
import icClose from '../../svg/ic_close_orange.svg'

export default {
    props: {
        addressesData: {
            required: true
        },
        favoriteAddressData: {
            required: true
        },
    },
    data() {
        return{
            hasUiActive:false,
            icWarning:icWarning,
            icAddress: icAddress,
            orangeStar: icOrangeStar,
            star: icStar,
            remove: icRemove,
            close: icClose,
            addressModal: false,
            alias: '',
            street: '',
            door: '',
            floor: '',
            side: '',
            postal_code: '',
            locality: '',
            isLoading: false,
            formError: {
                'alias': [],
                'street': [],
                'door': [],
                'side': [],
                'postal_code': [],
                'locality': [],
            },
        }
    },
    methods: {
        resetFormFields(){
            // Clear up form fields
            this.alias = '';
            this.street = '';
            this.door = '';
            this.floor = '';
            this.side='';
            this.postal_code= '';
            this.locality='';

            // Clear up form errors
            this.formError.alias = [];
            this.formError.street = [];
            this.formError.door = [];
            this.formError.side = [];
            this.formError.postal_code = [];
            this.formError.locality = [];
        },
        addressModalHandler(){
            this.addressModal = !this.addressModal
            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
        onCancel(){
            this.addressModal = false;
            document.querySelector('html').classList.remove('no-scroll');
            document.querySelector('body').classList.remove('no-scroll');

            this.resetFormFields();
        },
        addFavourite(alias) {
            location = `/favorite/address/${alias}`;
            this.hasUiActive = !this.hasUiActive
        },
        removeFavourite(alias) {
            location = `/remove/address/${alias}`;
            this.hasUiActive = !this.hasUiActive
        },
        removeAddress(alias){
            location = `/remove/address/${alias}`;
            this.hasUiActive = !this.hasUiActive
        },
        onConfirm(e){
            e.preventDefault();

            this.isLoading = true;
            this.$axios.post('/morada', {
                'alias': this.alias,
                'street': this.street,
                'door': this.door,
                'floor': this.floor,
                'side': this.side,
                'postal_code': this.postal_code,
                'locality': this.locality,
            })
            .then((response) => {
                location.reload();
            })
            .catch((error) => {
                switch (error.response.status) {
                    case 401:
                        this.$router.push('/logout');
                        break;
                    case 404:
                        //dont know what to do yet
                        this.isLoading = false;
                        break;
                    case 422:
                        this.formError = error.response.data;
                        this.isLoading = false;
                        break;
                    default:
                        //if error 500 => generic error
                        //TODO
                        this.isLoading = false;
                        break;
                }
            });
        }
    }
}
</script>
